import React, { useState, useEffect, useCallback } from 'react';
import { MdLocationOn, MdEmail, MdPhone } from 'react-icons/md';
import Dashboardbg3 from '../../images/Pool.png';
import Dashboardbg4 from '../../images/Resort2.png';
import amenitiesWithIcons from '../../data/amenitiesWithIcons';

const TurfInfo = ({ venueDetails, productId }) => {
  const productlist = venueDetails?.responseContent?.productDetails || [];
  const product = productlist.find(item => item.product_id === productId);

  const turfName = product?.turf_name || 'Turf Name Not Available';
  const address = product?.adress || 'Address Not Available';
  const locality = product?.locality || 'Locality Not Available';
  const city = product?.district_name || 'City Not Available';
  const state = product?.state_name || 'State Not Available';
  const pincode = product?.pin_code || 'Pincode Not Available';
  const phoneNumber = product?.phone_number || 'Contact Info Not Available';
  const email = product?.email_id || 'Email Not Available';
  const amenities = product?.amenities || [];

  const filteredIcons = amenitiesWithIcons.filter(iconObj => amenities.includes(iconObj.value));

  const images = product?.image || [Dashboardbg3, Dashboardbg4];
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  }, [images.length]);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [nextSlide]);

  return (
    <div style={{
      backgroundColor: '#1e1e1e', 
      border: '2px solid #ffcc00', 
      padding: '16px', 
      borderRadius: '8px',
      boxShadow: 'inset 0px 0px 10px rgba(0, 0, 0, 0.3)',
      color: '#d3d3d3',
      fontFamily: '"Courier New", Courier, monospace',
    }}>
      {/* Carousel Section */}
      <div style={{
        position: 'relative',
        height: '250px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#2a2a2a',
        borderRadius: '8px',
      }}>
        <img
          src={images[currentIndex]}
          alt="Turf"
          style={{
            width: '90%',
            height: '90%',
            objectFit: 'cover',
            transition: 'opacity 0.7s ease-in-out',
            borderRadius: '8px',
          }}
        />

        {/* Left Arrow */}
        <div
          onClick={prevSlide}
          style={{
            position: 'absolute',
            top: '50%',
            left: '10px',
            transform: 'translateY(-50%)',
            color: '#ffcc00',
            fontSize: '24px',
            cursor: 'pointer',
            backgroundColor: '#2a2a2a',
            borderRadius: '50%',
            padding: '8px',
            boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.5)',
          }}
        >
          &#8249;
        </div>

        {/* Right Arrow */}
        <div
          onClick={nextSlide}
          style={{
            position: 'absolute',
            top: '50%',
            right: '10px',
            transform: 'translateY(-50%)',
            color: '#ffcc00',
            fontSize: '24px',
            cursor: 'pointer',
            backgroundColor: '#2a2a2a',
            borderRadius: '50%',
            padding: '8px',
            boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.5)',
          }}
        >
          &#8250;
        </div>
      </div>

      {/* Amenities Section */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-around',
        padding: '12px',
        backgroundColor: '#2a2a2a',
        borderTop: '1px solid #ffcc00',
      }}>
        {filteredIcons.map((iconObj, index) => (
          <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#ffcc00', fontSize: '1.5rem' }}>
            {iconObj.icon}
            <span style={{ fontSize: '0.9rem', color: '#d3d3d3' }}>{iconObj.label}</span>
          </div>
        ))}
      </div>

      {/* Info Section */}
      <div style={{
        backgroundColor: '#1e1e1e',
        padding: '12px',
        borderRadius: '8px',
        border: '2px solid #ffcc00',
        marginTop: '16px',
      }}>
        <h3 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '8px' }}>{turfName}</h3>
        
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
          <MdLocationOn style={{ fontSize: '20px', marginRight: '8px' }} />
          <p>{`${address}, ${locality}, ${city}, ${state} ${pincode}`}</p>
        </div>
        
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
          <MdPhone style={{ fontSize: '20px', marginRight: '8px' }} />
          <p>{phoneNumber}</p>
        </div>
        
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
          <MdEmail style={{ fontSize: '20px', marginRight: '8px' }} />
          <p>{email}</p>
        </div>
      </div>

      {/* Console-style Button */}
      <button style={{
        backgroundColor: '#00ff00',
        border: '2px solid #004d00',
        color: '#1e1e1e',
        fontFamily: '"Courier New", Courier, monospace',
        padding: '10px 20px',
        borderRadius: '4px',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        marginTop: '16px',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
      }}
      onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#33cc33')}
      onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#00ff00')}
      >
        Continue
      </button>
    </div>
  );
};

export default TurfInfo;
